import { Box, TableContainer, Td } from '@chakra-ui/react';
import { CurrencyLabel, InvoiceLink } from '../components';
import { PaginatedTable } from '../components/PaginatedTable';
import { AfeInvoiceResponse } from 'api/bindings/AfeInvoiceResponse';

export interface AfeInvoicesSectionProps {
  invoices: AfeInvoiceResponse[] | undefined;
}

export const AfeInvoicesSection = (props: AfeInvoicesSectionProps) => {
  const { invoices = [] } = props;

  return (
    <Box>
      <TableContainer>
        <PaginatedTable
          items={invoices}
          columns={[
            {
              component: 'Invoice',
              sortKey: 'name',
            },
            {
              sortKey: 'pending',
              component: 'Pending',
              isNumeric: true,
            },
            {
              sortKey: 'total',
              component: 'Total',
              isNumeric: true,
            },
          ]}
        >
          {(i) => (
            <>
              <Td>
                <InvoiceLink i={i} />
              </Td>
              <Td>
                <CurrencyLabel value={i.pending} />
              </Td>
              <Td>
                <CurrencyLabel value={i.total} />
              </Td>
            </>
          )}
        </PaginatedTable>
        {/* <Table variant={'simple'}>
          <Thead>
            <Tr>
              <Th>Account</Th>
              <Th>Amount</Th>
            </Tr>
          </Thead>
          <Tbody>
            {lineItems.map((li, i) => (
              <Tr key={i}>
                <Td>
                  <SubAccountLabel value={li.subAccountId} />
                </Td>
                <Td>
                  <Currency value={li.amount} />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table> */}
      </TableContainer>
    </Box>
  );
};
